import { PLATFORM_STATS } from "../constants/platformStats";

export enum getTransporterFigureTypes {
    NUMERIC,
    THOUSANDS,
    MILLIONS,
    LAKHS,
    LAKH_NUMBER
}

export const getTransporterFigure = (type = getTransporterFigureTypes.LAKHS) => {
    switch (type) {
        case getTransporterFigureTypes.THOUSANDS:
            return "1000 Thousand+";

        case getTransporterFigureTypes.MILLIONS:
            return "1 Million+";

        case getTransporterFigureTypes.NUMERIC:
            return PLATFORM_STATS.transporters.numeric;

        case getTransporterFigureTypes.LAKH_NUMBER:
            return `${PLATFORM_STATS.transporters.lakhNumber}`;

        default:
            return PLATFORM_STATS.transporters.lakhsLong;
    }
};
